import { createOrder, depWay, drawOrder } from "@/services/api/account";
import router from "@/router";
import KwaiqEvent from "@/utils/KwaiqEvent";
import store from '@/store';
import { userMoney } from "@/services/api/user";
import ConstConfig from "@/config/ConstConfig";
import { changeAmount,changeMoney } from "@/utils/CurrencyUtils";
import { Toast } from 'vant';
import i18n from '@/i18n';
import utils from "@/utils/utils";


/**充值 */
export function toCharge(orderInfo) {
    if (orderInfo && orderInfo.amount) {
        let orderForm = {
            ...orderInfo,payType: store.state.payType
        }
        console.log("orderInfo",orderInfo)
        createOrder(orderForm).then(res => {
            if (res.success == false) {
                Toast(res.msg);
                return;
            } else {
                KwaiqEvent.EventDoAddToCartKwaiq(changeAmount(orderForm.amount));
                let url = res.data.payUrl;
                let u = navigator.userAgent;
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                isiOS?(window.location.href = url) : window.open(url);
                // router.push("/home");
            }
        });
    } else {
        if (store.state.localeLanguage == "BR") {
            Toast("Por favor, insira a conta de saques que precisa ser vinculada");
        } else {
            Toast("Please enter the withdrawal account that needs to be linked");
        }
    }
}

/**
 * 打开提示弹窗
 * handleType 弹窗类型  0:不做操作,1:跳转充值,2:跳转提现,3:跳转游戏,4:直接拉取充值(包括交税),5:跳转分享,6:修改账户
 * tipsContent 弹窗内容
 * btnContent 按钮内容
 * closeCallBack 关闭弹窗回调方法
 */

export function setOpenTips(handleType,tipsContent,btnContent,closeCallBack){
    store.state.tipsVisible  = true;
    store.state.tipsType = handleType;
    store.state.tipsMsg = tipsContent;
    store.state.tipsBtn = btnContent;
    if(closeCallBack){
        store.state.tipsMethod = closeCallBack;
    }else{
        store.state.tipsMethod = ()=>{};
    }
}

/**
 * 通过参数打开提示弹窗
 * {
 *   handleType 弹窗类型  0:不做操作,1:跳转充值,2:跳转提现,3:跳转游戏,4:直接拉取充值(包括交税),5:跳转分享,6:跳转修改账户,7:
 *   tipsContent 弹窗内容
 *   btnContent 按钮内容
 *   closeCallBack 关闭弹窗回调
 *   okCallBack 确定弹窗回调
 * }
 * @param param
 */
export function setOpenTipsByParam(param){
    store.state.tipsVisible  = true;
    store.state.tipsType = param.handleType;
    store.state.tipsMsg = param.tipsContent;
    store.state.tipsBtn = param.btnContent;
    if(param.closeCallBack){
        store.state.tipsMethod = param.closeCallBack;
    }else{
        store.state.tipsMethod = ()=>{};
    }
    if(param.okCallBack){
        store.state.tipsOkMethod = param.okCallBack;
    }else{
        store.state.tipsOkMethod = ()=>{};
    }
}

/**
 * 打开进度条弹窗
 * tipsContent 弹窗内容
 * closeCallBack 关闭弹窗回调
 */
export function setOpenProgressTips(tipsContent,closeCallBack){
    store.state.progressTipsVisible  = true;
    store.state.tipsProgressMsg = tipsContent;
    if(closeCallBack){
        store.state.tipsMethod = closeCallBack;
    }else{
        store.state.tipsMethod = ()=>{};
    }

}
/** 发起提现请求 */
export async function toWithDraw(amount) {
    let userAccount = localStorage.getItem(ConstConfig.LOCAL_CONST.USER_ACCOUNT);
    if (userAccount && userAccount !=='null') {
        userAccount = JSON.parse(userAccount);
        let order = {
            userName: userAccount.userName,
            accountNumber: userAccount.accountNumber,
            phone: userAccount.phone,
            email: userAccount.email,
            // payType: userAccount.payType,
            payType: store.state.payType,
            amount: amount,
            bankName: userAccount.bankName,
            branchBankName: userAccount.branchBankName
        }
        return await drawOrder(order);
       /* drawOrder(order).then(res => {
            if (res.success == true) {
                localStorage.setItem(ConstConfig.LOCAL_CONST.WITHDRAW_LAST_ORDER, res.data.orderId);
                localStorage.setItem(ConstConfig.LOCAL_CONST.WITHDRAW_FAIL_FLAG, "1");
                userMoney({}).then(res => {
                    if (res.success) {
                        let userAccount = res.data;
                        if (userAccount) {
                            store.state.gold = userAccount.gold;
                        }
                    }
                });
                let gameConfig = localStorage.getItem(ConstConfig.LOCAL_CONST.GAME_CONFIG);
                if (gameConfig) {
                    gameConfig = JSON.parse(gameConfig);
                    if (store.state.localeLanguage == "BR") {
                        // Toast('A ordem de saques foi enviada ao banco, preste atenção às alterações da conta bancária');
                    } else {
                        // Toast('The withdrawal order has been sent to the bank, please pay attention to bank account changes');
                    }
                } else {
                    // Toast('The withdrawal order has been sent to the bank, please pay attention to bank account changes');
                }
                // store.state.WithdrawPopups = 111;
                let account = res.data.account;
                if(account){
                    if(account.vipStep===7){
                        store.state.taxMoney = utils.accMul(amount,0.05);
                        let tax =changeMoney(store.state.taxMoney.toFixed(2))
                        setOpenTips(4,i18n.t("process.tipsLevel7",{'money':tax}),i18n.t("process.payTax"));
                    }else if(account.vipStep===6){
                        // setOpenTips(1,i18n.t("process.tipsLevel6"),i18n.t("process.toCharge"));
                        //创建定时器 10秒后弹窗提示
                        store.state.isShowStep6Tips = true;
                        setTimeout(()=>{
                            if(store.state.isShowStep6Tips){
                                store.state.taxMoney = 30000
                                setOpenTips(4,i18n.t("process.tipsLevel6"),i18n.t("process.toCharge"));
                            }
                        },1000*15)
                        // 提现申请成功
                        setOpenTips(0,i18n.t("process.tips4"),i18n.t("WithdrawPopups.5"));
                        store.state.withdrawSelectKey = 1;//跳转到提现记录页面
                    }else if(account.vipStep===1){
                        // 提现申请成功
                        setOpenTips(0,i18n.t("withdraw.tips4"),i18n.t("WithdrawPopups.5"));
                        store.state.withdrawSelectKey = 1;//跳转到提现记录页面
                    }else{
                        setOpenTips(0,i18n.t("process.tips4"),i18n.t("WithdrawPopups.5"));
                    }
                }else{
                    if(store.state.vipStep === 1){
                        // 提现申请成功
                        setOpenTips(0,i18n.t("withdraw.tips4"),i18n.t("WithdrawPopups.5"));
                    }else{
                        // 提现申请成功
                        setOpenTips(0,i18n.t("process.tips4"),i18n.t("WithdrawPopups.5"));
                    }
                    store.state.withdrawSelectKey = 1;//跳转到提现记录页面
                }
            } else {
                store.state.WithdrawPopups = 500;//错误弹窗
                store.state.tipsVisible = true;
                store.state.tipsBtn=i18n.t("WithdrawPopups.5");
                store.state.tipsType = 0;
                if(res.msgCode==='too_many_people'){
                    store.state.tipsMsg=i18n.t("process.tipsLevel4");
                }else if(res.msgCode==='already_withdraw'){ //已经提过现
                    store.state.tipsMsg=i18n.t("process.tips5");
                }else if(res.msgCode==='account_balance_not_enough'){ //余额不足
                    store.state.tipsMsg=i18n.t("tips.notGold");
                }else{
                    store.state.tipsMsg = res.msg;
                }
              // Toast(res.msg);
            }
        });*/
    } else {
        if (store.state.localeLanguage == "BR") {
            Toast("Por favor, insira a conta de saques que precisa ser vinculada");
        } else {
            Toast("Please enter the withdrawal account that needs to be linked");
        }
    }
}
